<template>
  <div>
    <div class="stepOne-class">
      <p>{{ $t('app.invoice.apply.step1.title') }}</p>
      <div class="src-pages-finance">
        <div class="left-class">
          <div class="left-top-class">
            <span>{{ $t('app.invoice.apply.step1.uninvoicedOrders') }}</span>
            <span></span>
          </div>
          <div class="left-bottom-class">
            <el-table :data="tableData"  ref="multipleTable" :header-cell-style ="{background: '#EEF1F6',color: '#606266'}" @selection-change="handleSelectionChange">
              <el-table-column type="selection" align="center"></el-table-column>
              <el-table-column prop="orderId" :label="$t('app.invoice.apply.step1.table.item')" align="center"></el-table-column>
              <el-table-column prop="rechargeMoney" :label="$t('app.invoice.apply.step1.table.amount')" align="center"></el-table-column>
              <el-table-column prop="payTime" :label="$t('app.invoice.apply.step1.table.rechargeTime')" align="center"></el-table-column>
              <el-table-column prop="remark" :label="$t('app.invoice.apply.step1.table.description')" align="center"></el-table-column>
            </el-table>
          </div>
        </div>
        <div class="right-class">
          <div class="left-top-class">
            <span>{{ $t('app.invoice.apply.step1.selected') }}</span>
            <span>{{ $t('app.invoice.apply.step1.totalItems', { num: num }) }}</span>
          </div>
          <div class="right-bottom-class">
            <div class="right-bottom-top" v-if="sumMoney > '0'">
              <div style="font-size: 16px;color: #606266;">{{ $t('app.invoice.apply.step1.rechargeInvoice') }}</div>
              <div>
                <span>¥ {{sumMoney}}</span>
                <i class="el-icon-close delete-class" @click="del"></i>
              </div>
            </div>
            <div v-if="sumMoney == '0'" class="zanwu-class">{{ $t('app.invoice.apply.step1.noData') }}</div>
          </div>
          <div class="right-bottom-bottom">
            <span>{{ $t('app.invoice.apply.step1.amount') }}：</span>
            <span class="je">¥ {{sumMoney}}</span>
          </div>
        </div>
      </div>
      <p class="bze-class">{{ $t('app.invoice.apply.step2.title') }}  <span class="src-pages-class">{{ $t('app.invoice.apply.step2.note') }}</span></p>
      <div >
        <el-form ref="pppropsParams" :rules="ruleValidate" :model="propsParams" label-width="130px">
          <el-form-item :label="$t('app.invoice.apply.form.invoiceType')" prop="type">
              <el-radio v-model="type" label="1" @change="selectLx()">{{ $t('app.invoice.apply.form.electronicGeneral') }}</el-radio>
              <el-radio v-model="type" label="2" @change="selectLx()">{{ $t('app.invoice.apply.form.electronicSpecial') }}</el-radio>
          </el-form-item>
          <el-form-item label="" prop="explain" class="el-form-explain">
            <span class="explain-class">{{explain}}</span>
          </el-form-item>

          <el-form-item :label="$t('app.invoice.apply.form.invoiceContent')" prop="fpnr">
            <span>{{ $t('app.invoice.apply.form.itServiceFee') }}</span>
          </el-form-item>
          <el-form-item :label="$t('app.invoice.apply.form.invoiceAmount')" prop="money">
            <span>¥ {{sumMoney}}</span>
          </el-form-item>
          <div v-if="type == '1'">
            <el-form-item :label="$t('app.invoice.apply.form.invoiceTitle')" prop="title">
              <el-input v-model="propsParams.title" :placeholder="$t('app.invoice.apply.form.placeholder.invoiceTitle')" style="width: 380px"></el-input>
            </el-form-item>
            <el-form-item :label="$t('app.invoice.apply.form.taxId')" prop="ein">
              <el-input v-model="propsParams.ein" :placeholder="$t('app.invoice.apply.form.placeholder.taxId')" style="width: 380px"></el-input>
            </el-form-item>
            <el-form-item :label="$t('app.invoice.apply.form.receivePhone')" prop="phone">
              <el-input v-model="propsParams.phone" :placeholder="$t('app.invoice.apply.form.placeholder.receivePhone')" style="width: 380px"></el-input>
            </el-form-item>
            <el-form-item :label="$t('app.invoice.apply.form.receiveEmail')" prop="email">
              <el-input v-model="propsParams.email" :placeholder="$t('app.invoice.apply.form.placeholder.receiveEmail')" style="width: 380px"></el-input>
            </el-form-item>
            <el-form-item :label="$t('app.invoice.apply.form.bankAccount')" prop="bankAccount">
              <el-input v-model="propsParams.bankAccount" :placeholder="$t('app.invoice.apply.form.placeholder.bankAccount')" style="width: 380px"></el-input>
            </el-form-item>
            <el-form-item :label="$t('app.invoice.apply.form.bankName')" prop="bank">
              <el-input v-model="propsParams.bank" :placeholder="$t('app.invoice.apply.form.placeholder.bankName')" style="width: 380px"></el-input>
            </el-form-item>
            <el-form-item :label="$t('app.invoice.apply.form.companyPhone')" prop="businessPhone">
              <el-input v-model="propsParams.businessPhone" :placeholder="$t('app.invoice.apply.form.placeholder.bankName')" style="width: 380px"></el-input>
            </el-form-item>
            <el-form-item :label="$t('app.invoice.apply.form.companyAddress')" prop="businessAddress">
              <el-input v-model="propsParams.businessAddress" :placeholder="$t('app.invoice.apply.form.placeholder.companyAddress')" style="width: 380px"></el-input>
            </el-form-item>
          </div>
          <div v-if="type == '2'">
            <el-form ref="zpPropsParams" :rules="zpRuleValidate" :model="zpPropsParams" label-width="130px">
              <el-form-item :label="$t('app.invoice.apply.form.special.invoiceInfo')" prop="title">
                <div class="zhuanpiao-class">
                  <div class="fptt-class">
                    <div>
                      <span>{{ $t('app.invoice.apply.form.invoiceTitle') }}：</span>
                      <span>{{zpxxData.title}}</span>
                    </div>
                    <div style="cursor: pointer;" @click="changeInformation">
                      <i class="el-icon-edit">{{ $t('app.common.change') }}</i>

                    </div>
                  </div>
                  <div class="fptt-class">
                    <div>
                      <span>{{ $t('app.invoice.apply.form.taxId') }}：</span>
                      <span>{{zpxxData.ein}}</span>
                    </div>
                    <div>
                      <span>{{ $t('app.invoice.apply.form.special.bankName') }}：</span>
                      <span>{{zpxxData.bank}}</span>
                    </div>
                  </div>
                  <div class="fptt-class">
                    <div>
                      <span>{{ $t('app.invoice.apply.form.special.bankAccount') }}：</span>
                      <span>{{zpxxData.bankAccount}}</span>
                    </div>
                    <div>
                      <span>{{ $t('app.invoice.apply.form.special.accountName') }}：</span>
                      <span>{{zpxxData.basicName}}</span>
                    </div>
                  </div>
                  <div class="fptt-class">
                    <div>
                      <span>{{ $t('app.invoice.apply.form.companyPhone') }}：</span>
                      <span>{{zpxxData.businessPhone}}</span>
                    </div>
                    <div></div>
                  </div>
                  <div class="fptt-class">
                    <div>
                      <span>{{ $t('app.invoice.apply.form.companyAddress') }}：</span>
                      <span>{{zpxxData.businessAddress}}</span>
                    </div>
                    <div></div>
                  </div>
                </div>
              </el-form-item>
              <el-form-item :label="$t('app.invoice.apply.form.special.receivePhone')" prop="phone">
                <el-input v-model="zpPropsParams.phone" :placeholder="$t('app.invoice.apply.form.placeholder.receivePhone')" style="width: 380px"></el-input>
              </el-form-item>
              <el-form-item :label="$t('app.invoice.apply.form.special.receiveEmail')" prop="email">
                <el-input v-model="zpPropsParams.email" :placeholder="$t('app.invoice.apply.form.placeholder.receiveEmail')" style="width: 380px"></el-input>
              </el-form-item>
            </el-form>
          </div>
        </el-form>
      </div>
      <div class="anniu">
        <el-button type="primary" @click="submitData" v-hasPermi="['order:invoice:apply']">{{ $t('app.invoice.apply.button.submit') }}</el-button>
      </div>
      <!-- 弹窗部分 -->
      <el-dialog :title="title" :visible.sync="dialog" @close="dialogClose" :lock-scroll="false" v-dialogDrag width="550px" :close-on-click-modal="false">
        <el-form :model="form" label-width="80px" ref="form" :rules="rules">
          <el-form-item label="发票抬头：" prop="title" label-width="150px">
            <el-input v-model="form.title" autocomplete="off" style="width: 300px" placeholder="请输入发票抬头"></el-input>
          </el-form-item>
          <el-form-item label="税务登记号：" prop="ein" label-width="150px">
            <el-input v-model="form.ein" autocomplete="off" style="width: 300px" placeholder="请输入税务登记号"></el-input>
          </el-form-item>
          <el-form-item label="公司注册地址：" prop="businessAddress" label-width="150px">
            <el-input v-model="form.businessAddress" autocomplete="off" style="width: 300px" placeholder="请输入公司注册地址"></el-input>
          </el-form-item>
          <el-form-item label="公司联系方式：" prop="businessPhone" label-width="150px">
            <el-input v-model="form.businessPhone" autocomplete="off" style="width: 300px" placeholder="请输入公司联系方式"></el-input>
          </el-form-item>
          <el-form-item label="基本户开户银行：" prop="bank" label-width="150px">
            <el-input v-model="form.bank" autocomplete="off" style="width: 300px" placeholder="请输入基本户开户银行"></el-input>
          </el-form-item>
          <el-form-item label="基本户开户账号：" prop="bankAccount" label-width="150px">
            <el-input v-model="form.bankAccount" autocomplete="off" style="width: 300px" placeholder="请输入基本户开户账号"></el-input>
          </el-form-item>
          <el-form-item label="基本户开户名：" prop="basicName" label-width="150px">
            <el-input v-model="form.basicName" autocomplete="off" style="width: 300px" placeholder="请输入基本户开户名"></el-input>
          </el-form-item>
        </el-form>
        <div class="dialog-footer" slot="footer">
          <el-button type="primary" @click="cancelDialog()">取消</el-button>
          <el-button type="success" @click="saveInfo()">保存</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import { getInvoiceList } from "@/api/api.js";
import { invoiceSaveInvoice } from "@/api/api.js";
import { invoiceSaveInvoiceCompany } from "@/api/api.js";
import { invoiceUserInvoice } from "@/api/api.js";
export default {
  data() {
    return {
      tableData:[],
      sumMoney:"0",
      num:"0",
      type:"1",
      expressAmount:"22",
      arrivalpaymentShow:true,
      propsParams:{},
      orderlist:[],
      ruleValidate:{
        title:[
          { required: true, message: '请输入发票抬头', trigger: 'blur' }
        ],
        ein:[
          { required: true, message: '请输入公司税号', trigger: 'blur' }
        ],
        phone:[
          { required: true, message: '请输入收票手机号', trigger: 'blur' }
        ],
        email:[
          { required: true, message: '请输入收票邮箱', trigger: 'blur' }
        ],
      },
      zpPropsParams:{},
      zpRuleValidate:{
        phone:[
          { required: true, message: '请输入收票手机', trigger: 'blur' }
        ],
        email:[
          { required: true, message: '请输入收票邮箱', trigger: 'blur' }
        ],
      },
      // 弹窗部分
      title:"发票信息",
      dialog:false,
      form:{},
      rules:{
        title:[
          { required: true, message: '请输入发票抬头', trigger: 'blur' }
        ],
        ein:[
          { required: true, message: '请输入公司税号', trigger: 'blur' }
        ],
        businessAddress:[
          { required: true, message: '请输入公司注册地址', trigger: 'blur' }
        ],
        businessPhone:[
          { required: true, message: '请输入公司联系方式', trigger: 'blur' }
        ],
        bank:[
          { required: true, message: '请输入基本户开户银行', trigger: 'blur' }
        ],
        bankAccount:[
          { required: true, message: '请输入基本户开户账号', trigger: 'blur' }
        ],
        basicName:[
          { required: true, message: '请输入基本户开户名', trigger: 'blur' }
        ],
      },
      zpxxData:{},
      explain: this.$t('app.invoice.apply.form.explain.1')
    };
  },
  methods: {
    // 初始化数据
    initData() {
      getInvoiceList().then(res=>{
        if(res.data.code == 200){
          this.tableData = res.data.data
        }
      }),
      invoiceUserInvoice().then(res=>{
        if(res.data.code == 200){
          this.zpxxData = res.data.data
        }
      })
    },
    handleSelectionChange(val) {
      let arrlist = [];
      this.orderlist = [];
      val.map(item=>{
        arrlist.push(item.rechargeMoney);
        this.orderlist.push(item.orderId);
      });
      this.sumMoney = this.sum(arrlist) > 1 ? this.sum(arrlist):0;
      if(this.sumMoney >= 1000){
       this.expressAmount = "0"
       this.arrivalpaymentShow = false
      }else{
       this.arrivalpaymentShow = true
      }
      this.num = this.sumMoney > 1 ? 1:0;
    },
    sum(arr) {
      return eval(arr.join("+"));
    },
    del(){
      this.$refs.multipleTable.clearSelection();
    },
    selectLx(){
      if(this.type == 2){
       for(let i in this.propsParams) {
         this.propsParams[i]  = ""
       }
       this.explain = this.$t('app.invoice.apply.form.explain.2')
      }else{
       this.explain = this.$t('app.invoice.apply.form.explain.1')
      }
    },
    // 更改信息的弹窗
    changeInformation(){
       this.form = this.zpxxData;
      this.dialog = true;
    },
    // 弹窗的x
    dialogClose(){
      this.$refs.form.clearValidate();
      this.dialog = false;
    },
    // 弹窗的取消
    cancelDialog(){
      this.dialog = false;
    },
    saveInfo(){
      this.$refs.form.validate(valid => {
        if(valid){
          let params = {
            ...this.form
          }
          invoiceSaveInvoiceCompany(params).then(res=>{
            if(res.data.code == 200){
              this.dialog = false;
              this.zpxxData = res.data.data
            }
          })
        }
      })

    },
    // 信息提交
    submitData(){
      if(this.type == "1"){
        this.$refs.pppropsParams.validate(valid => {
          if (valid) {
            let params ={
              ...this.propsParams
            };
            params.type = "1";
            params.orders = this.orderlist;
            invoiceSaveInvoice(params).then(res=>{
              if(res.data.code == 200){
                 this.$notify({
                  title: '成功',
                  message: '开票成功',
                  type: 'success',
                  offset:30
                });
                this.$emit('changeActiveTab')
              }else{
                this.$message.error(res.data.message);
              }
            })
          }
        })
      }else{
        this.$refs.zpPropsParams.validate(valid => {
          if(valid){
            let params ={
              ...this.zpPropsParams
            };
            params.title = this.zpxxData.title;
            params.ein = this.zpxxData.ein;
            params.businessAddress = this.zpxxData.businessAddress;
            params.businessPhone = this.zpxxData.businessPhone;
            params.bank = this.zpxxData.bank;
            params.bankAccount = this.zpxxData.bankAccount;
            params.basicName = this.zpxxData.basicName;
            params.type = "2";
            params.orders = this.orderlist;
            invoiceSaveInvoice(params).then(res=>{
              if(res.data.code == 200){
                 this.$notify({
                  title: '成功',
                  message: '开票成功',
                  type: 'success',
                  offset:30
                });
                this.$emit('changeActiveTab')
              } else if(res.data.code == 406){
                this.$message.error(res.data.message);
                this.$router.push({ path: `/users/onlinepay` });
              } else {
                this.$message.error(res.data.message);
              }
            })
          }
        })
      }
    }
  },
  created() {
    this.initData()
  },
  mounted() {},
};
</script>
<style scoped lang="less">
  .src-pages-finance {
    display: flex;
    justify-content: space-between;
    width: 100%;
    margin-top: 15px;
  }
  .left-class{
    width: 64%;
    border: 1px solid #c6cbdd;
    border-radius: 2px;
    .left-top-class{
      height: 40px;
      line-height: 40px;
      border-bottom: 1px solid #e6e7eb;
      display: flex;
      justify-content: space-between;
      padding: 0 16px;
    }
    .left-bottom-class{
      height: 320px;
      width: 100%;
      padding: 16px 16px 0;
      overflow-y: scroll;
    }
  }
  .right-class{
    width: 33%;
    border: 1px solid #c6cbdd;
    border-radius: 2px;
    .left-top-class{
      height: 40px;
      line-height: 40px;
      border-bottom: 1px solid #e6e7eb;
      display: flex;
      justify-content: space-between;
      padding: 0 16px;
    }
    .right-bottom-class{
      padding: 16px 16px 0;
      height: 270px;
      .right-bottom-top{
        display: flex;
        justify-content: space-between;
        padding: 12px 12px 12px 16px;
        background: #EEF1F6;
        .delete-class{
          font-size: 24px;
          margin-left: 15px;
          position: relative;
          top: 3px;
        }
      }
    }
    .right-bottom-bottom{
      height: 50px;
      line-height: 50px;
      display: flex;
      justify-content: space-between;
      // background-color: #EEF1F6;
      padding: 0 16px;
      .je{
        font-size: 20px;
        font-weight: bold;
      }
    }
  }
  .bze-class{
    margin: 15px 0;
  }
  .anniu{
    margin-left: 130px;
    margin-top: 80px;
    padding-bottom: 30px;
  }
  .zhuanpiao-class{
    width: 645px;
    height: 200px;
    background: #EFF2F7;
    .fptt-class{
      padding: 0 20px;
      display: flex;
      justify-content: space-between;
    }
  }
  .zanwu-class{
    margin: 100px auto;
    text-align: center;
  }
  .src-pages-class{
    font-size: 13px;
    color: rgba(52,60,101,.5);
  }
  .df-class{
    width: 38px;
    height: 22px;
    line-height: 1.5;
    display: inline-block;
    text-align: center;
    color: #3364ff;
    margin-left: 9px;
    border: 1px solid #99b1ff;
    background-color: #eaefff;
  }
  .el-form-explain{
    margin: -35px 0;
  }
  .explain-class{
    color: rgba(52,60,101,.5);
    font-size: 13px;
  }
  /deep/ .el-form-item{
    margin-bottom: 30px;
  }
</style>


